import {
    RESOURCE_METADATA_CONTROL,
    RESOURCE_METADATA_INVALID_JSON_ERROR,
    RESOURCE_METADATA_INVALID_JSON_MESSAGE,
    RESOURCE_METADATA_TOO_LONG_ERROR,
    RESOURCE_METADATA_TOO_LONG_MESSAGE,
} from '../constants';

import type {ValidationContextType} from 'src/contexts/validation-context';

export const validateMetadata = (
    metadata: string | undefined,
    addError: ValidationContextType['addError'],
): boolean => {
    let valid = true;

    if (metadata && metadata.trim()) {
        let parsed: unknown;
        try {
            parsed = JSON.parse(metadata);
            if (
                typeof parsed !== 'object' ||
                parsed === null ||
                (Array.isArray(parsed) && parsed.length === 0) ||
                (!Array.isArray(parsed) && Object.keys(parsed).length === 0)
            ) {
                addError({
                    controlId: RESOURCE_METADATA_CONTROL,
                    code: RESOURCE_METADATA_INVALID_JSON_ERROR,
                    message: RESOURCE_METADATA_INVALID_JSON_MESSAGE,
                });
                valid = false;
            }
        } catch {
            addError({
                controlId: RESOURCE_METADATA_CONTROL,
                code: RESOURCE_METADATA_INVALID_JSON_ERROR,
                message: RESOURCE_METADATA_INVALID_JSON_MESSAGE,
            });
            valid = false;
        }
    }

    if (metadata && metadata.length > 1024) {
        addError({
            controlId: RESOURCE_METADATA_CONTROL,
            code: RESOURCE_METADATA_TOO_LONG_ERROR,
            message: RESOURCE_METADATA_TOO_LONG_MESSAGE,
        });
        valid = false;
    }

    return valid;
};
